angular.module('callX').controller('ReportsPromoNumbersCtrl', ['$scope', 'UserService', 'ReportsService', 'DateService', '$state', function($scope, UserService, ReportsService, DateService, $state) {

    $scope.rankBy = "revenue";
    $scope.Math = window.Math;
    $scope.tableContentLoading = false;

    var init = function(){
//        console.log(DateService.getDateObj());
        var TempDateObj = DateService.getDateObj();
        if(TempDateObj.timezone!=undefined){
            $scope.fetchReportsData(TempDateObj.activeDate, TempDateObj.dateRangeValue);
        }
    };

    $scope.toggleRankBy = function(rankBy){
        $scope.rankBy = rankBy;
        init();
    };

    $scope.orderParam = 'revenue';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
//        console.log("Here!", orderParam);
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var setViewData = function(data){
        $scope.tableData = data.data.list;
        $scope.tableData.totals = {
            calls: 0,
            repeat_calls: 0,
            unique_calls: 0,
            paid_calls: 0,
            conv: 0,
            unique_conv: 0,
            revenue: 0,
            rpc: 0,
            avg_connect_duration: 0
        };
        for(var i = 0; i < $scope.tableData.length; i++){
            $scope.tableData.totals.calls += $scope.tableData[i].calls;
            $scope.tableData.totals.repeat_calls += $scope.tableData[i].repeat_calls;
            $scope.tableData.totals.unique_calls += $scope.tableData[i].unique_calls;
            $scope.tableData.totals.paid_calls += $scope.tableData[i].paid_calls;
            $scope.tableData.totals.conv += $scope.tableData[i].conv;
            $scope.tableData.totals.unique_conv += $scope.tableData[i].unique_conv;
            $scope.tableData.totals.revenue += $scope.tableData[i].revenue;
            $scope.tableData.totals.rpc += $scope.tableData[i].rpc;
        }
        $scope.tableData.totals.conv = $scope.tableData.totals.conv / $scope.tableData.length;
        $scope.tableData.totals.unique_conv = $scope.tableData.totals.unique_conv / $scope.tableData.length;
        $scope.tableData.totals.rpc = $scope.tableData.totals.rpc / $scope.tableData.length;
    };

    var fetchGraphAndTableData = function(activeDate, dateRangeValue){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                setViewData(data);
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        ReportsService.getGraphAndTableData('promo-number', activeDate, dateRangeValue, $scope.rankBy, callbacks);
    };

    $scope.fetchReportsData = function(activeDate, dateRangeValue){
        fetchGraphAndTableData(activeDate, dateRangeValue);
    };

    $scope.getPromoCodeGranularData = function(name, gId, callType, state, dayPart){
        var currentUserData = UserService.getCurrentUserData();
        $state.go('app.reports.promo-granular', { 'userId': currentUserData.id, 'rankBy': $scope.rankBy, 'state': state, 'dayPart': dayPart, 'activeData': 'promo-number', 'gId': gId, 'callType': callType, 'name': name  });
    };

    $scope.$on('dateObjUpdate', function(event, dateObj) {
        $scope.fetchReportsData(dateObj.activeDate, dateObj.dateRangeValue);
    });

    var getIndexFromId = function(id){
        var idx = -1;
        for(var i = 0; i < $scope.tableData.length; i++){
            if ($scope.tableData[i].id == id){
                idx = i;
                break;
            }
        }
        return idx;
    };

    var processingGeoLocData = false;
    $scope.getGeoLocsForCampaign = function(campaignId, phone_number){
        var index = getIndexFromId(campaignId);
//        console.log("$scope.tableData[index].showGeoLocs",$scope.tableData[index].showGeoLocs);
        if(!$scope.tableData[index].showGeoLocs && !processingGeoLocData){
            processingGeoLocData = true;
            $scope.tableData[index].processingDrillDownData = true;
            var currentDateObj = DateService.getDateObj();
            var currentUserData = UserService.getCurrentUserData();
            var callbacks = {
                success: function(data) {
//                    console.log("Drilldown Data", data);
                    if(data.data!=undefined){
                        $scope.tableData[index].geoLocData = data.data.list;
                    }
                    else{
                        $scope.tableData[index].geoLocData=[];
                    }
                    $scope.tableData[index].showGeoLocs = true;
                    if($scope.tableData[index].showDayParting){
                        $scope.tableData[index].showDayParting = false;
                    }
                    processingGeoLocData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                },
                failure: function(data) {
                    processingGeoLocData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                }
            };
            ReportsService.getGeoData(currentUserData.id, 'promo-number', currentDateObj.activeDate, currentDateObj.dateRangeValue, phone_number, callbacks)
        }
        else{
            $scope.tableData[index].showGeoLocs = false;
        }
    };

    var processingDayPartingData = false;
    $scope.getDayPartingDataForCampaign = function(campaignId, phone_number){
        var index = getIndexFromId(campaignId);
        if(!$scope.tableData[index].showDayParting && !processingDayPartingData) {
            processingDayPartingData = true;
            $scope.tableData[index].processingDrillDownData = true;
            var currentDateObj = DateService.getDateObj();
            var currentUserData = UserService.getCurrentUserData();
            var callbacks = {
                success: function (data) {
//                    console.log("Time Drilldown Data", data);
                    if(data.data!=undefined){
                        $scope.tableData[index].dayPartingData = data.data.list;
                    }
                    else{
                        $scope.tableData[index].dayPartingData=[];
                    }
                    $scope.tableData[index].showDayParting = true;
                    processingDayPartingData = false;
                    if($scope.tableData[index].showGeoLocs){
                        $scope.tableData[index].showGeoLocs = false;
                    }
                    $scope.tableData[index].processingDrillDownData = false;
                },
                failure: function (data) {
                    processingDayPartingData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                }
            };
            ReportsService.getDayPartData(currentUserData.id, 'promo-number', currentDateObj.activeDate, currentDateObj.dateRangeValue, phone_number, callbacks)
        }
        else{
            $scope.tableData[index].showDayParting = false;
        }
    };

    init();

}]);